jQuery( document ).ready(function(){


  jQuery('.menu-open').on('click',function() {
    jQuery('.menu-dropdown').slideDown();
    jQuery('.menu-open').hide();
    jQuery('.menu-close').show();

  })

  jQuery('.menu-close').on('click',function() {
    jQuery('.menu-dropdown').slideUp();
    jQuery('.menu-close').hide();
    jQuery('.menu-open').show();

  })

})